import * as API from "./Api";

export const getJobsByCreatorStatus = (status, page, limit) =>
  API.get(`job-creator/${status}?page=${page}&limit=${limit}`);
export const getCreatorJobById = (id) => API.get(`job-creator/details/${id}`);
export const applyJob = (data) => API.post("job-creator/apply", data);
export const creatorJobAction = (id, data) =>
  API.put(`job-creator/requested-job-action/${id}`, data);
